export default __webpack_public_path__ + "static/adorno11-e4bf45712635d76c175aa9dafe1d334d.png";